import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
@Component({
  selector: 'app-community-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './community-header.component.html',
  styleUrls: ['./community-header.component.css']
})
export class CommunityHeaderComponent{
  @Input() community: any; 
  @Input() communityStats: any;
  profilePhoto = 'https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Sign-Up-Image.jpg';
  currentSlug = '';
  currentCommunityId = '';
 

 constructor(
    private router: Router,
  ) {}

  goToUserList(): void {
    this.currentSlug = localStorage.getItem('slug') || '';
    this.currentCommunityId = localStorage.getItem('communityId') || '';
    this.router.navigate([`/${this.currentSlug}/${this.currentCommunityId}/community-users`]);
  }
}
